import { AddCircleIcon } from "../../constants/icon_path";

const AddIcon = ({ onClick }) => {
  return (
    <AddCircleIcon
      style={{ cursor: "pointer" }}
      size={40}
      color="green"
      onClick={() => onClick()}
    />
  );
};

export default AddIcon;
